import React from "react";
import ReactModal from "react-modal";

import { Button } from "@/design-system/components/Button/Button";
import { EditableProject } from "../reducers/environments";

const modalStyles = {
  content: {
    zIndex: 10050,
    minHeight: `100px`,
    width: 600,
    top: "auto",
    bottom: "auto",
    right: "auto",
    left: "auto",
    position: "static" as "static",
    display: "flex",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, .8)",
    zIndex: 10000,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
export type ProjectDeletionModalState = {
  project: EditableProject;
  onClose?: () => void;
  onDelete: (project: EditableProject) => void;
};

export const DeleteProjectModal: React.FC<ProjectDeletionModalState> = ({
  project,
  onClose,
  onDelete,
}) => {
  const onConfirm = React.useCallback(() => {
    onDelete(project);
  }, [onDelete, project]);

  return (
    <ReactModal
      isOpen={true}
      onRequestClose={onClose}
      style={modalStyles}
      contentLabel="Delete Project?"
    >
      <div className="flex w-full flex-col justify-between">
        <div className="mb-4 border-b pb-4">
          <h2>Delete Project?</h2>
          <h4 className="text-md text-textSubtle font-bold uppercase">
            Project: {project.name}
          </h4>
        </div>

        <p className="text-textSecondary text-xs">
          This action will delete this project as well as its environments
        </p>

        <div className="mt-8 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </div>
    </ReactModal>
  );
};
